var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Header'),_c('div',{staticClass:"management-wrap common-inner"},[_c('h2',{staticClass:"text-h4 text-center"},[_vm._v("会員アカウントの管理")]),_c('Table')],1),_c('ManagementFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }